/**
 * Action Header
 */
import React from 'react';

import { Row } from 'react-table';

import { Action, ActionMenu } from '~shared/components/ActionMenu/ActionMenu';
import { IconEllipsis } from '~shared/components/icons/standard';

interface ActionHeaderProps<T extends object> {
  enableBulkActions: boolean;
  selectedFlatRows: Row<T>[];
  actions: Action<T>[];
}
export const ActionHeader = <T extends object>({
  enableBulkActions,
  selectedFlatRows,
  actions,
}: ActionHeaderProps<T>) => {
  if (!enableBulkActions) return <></>;
  return (
    <div className={'th-outskirts'}>
      {selectedFlatRows.length > 0 ? (
        <div className={'bubble'}>{selectedFlatRows.length}</div>
      ) : (
        ''
      )}
      <ActionMenu
        isDisabled={selectedFlatRows.length === 0}
        actions={actions}
        data={selectedFlatRows.map((i) => i.original)}
      >
        <div className={'actions'}>
          <IconEllipsis />
        </div>
      </ActionMenu>
    </div>
  );
};
